import $ from 'jquery';
import Animation from 'modules/animation/animation';

export default class {
	constructor(options) {
		const defaults = {
			el: '#yotaOrderSimSms',
			dom: {
				code: '#yotaOrderSimSmsCode',
				again: '#yotaOrderSimSmsAgain',
				wait: '#yotaOrderSimSmsWait',
				cmd: '#yotaOrderSimSmsCmd'
			},
			classes: {
				wait: 'b-order-sim-sms_state_wait',
				error: 'b-field_state_error'
			},
			code: {
				max: 6,
				min: 6
			},
			time: 60
		};

		this.options = $.extend(true, {}, defaults, options);
		this.$el = $(this.options.el);
		this.$window = $(window);


		this.send = false;
		this.timer = 0;
		this.interval = false;
		return this;
	}

	getDom() {
		this.$code = this.$el.find(this.options.dom.code);
		this.$again = this.$el.find(this.options.dom.again);
		this.$wait = this.$el.find(this.options.dom.wait);
		this.$cmd = this.$el.find(this.options.dom.cmd);
		return this;
	}

	getHtmlOptions() {
		this.options.code.max = this.$code.data('max') || this.options.code.max;
		this.options.code.min = this.$code.data('min') || this.options.code.min;
		this.options.time = this.$wait.data('time') || this.options.time;
	}

	onInput(event) {
		const $target = $(event.currentTarget);
		this.$code.parent().removeClass(this.options.classes.error);
		const val = $target.val();
		if (val.length > this.options.code.max) {
			$target[0].value = val.substr(0, this.options.code.max);
		}
	}

	onSubmit(event) {
		const self = this;
		event.preventDefault();
		if (!self.send) {
			const code = self.$code.val();
			if (code.length > self.options.code.max || code.length < self.options.code.min) {
				self.$code.parent().addClass(self.options.classes.error);
				$(() => new Animation({el: self.$code.parent().parent()}).play('shake'));
			} else {
				self.send = true;
				self.$cmd.val('confirm');
				$.ajax({
					url: self.$el.attr('action'),
					type: self.$el.attr('method'),
					data: self.$el.find(':input').serialize(),
					dataType: 'json',
					success: function (json) {
						if (json && json.success) {
							if (json.location) {
								window.location.assign(json.location);
							}
						} else {
							self.$code.parent().addClass(self.options.classes.error);
							$(() => new Animation({el: self.$code.parent().parent()}).play('shake'));
						}
						self.send = false;
					}
				});
			}
		}
	}

	onResend(event) {
		event.preventDefault();
		const self = this;
		self.$cmd.val('resend');
		if (self.timer <= 0) {
			self.timer = 1;
			$.ajax({
				url: self.$again.attr('href'),
				type: self.$again.attr('method'),
				data: {cmd: 'resend'},
				dataType: 'json',
				success: function (json) {
					if (json && json.success) {
						self.startTimer(json.timer || 60);
					} else {
						self.timer = 0;
					}
				}
			});
		}
	}

	declOfNum(number, titles) {
		const cases = [2, 0, 1, 1, 1, 2];
		return titles[(number % 100 > 4 && number % 100 < 20) ? 2 : cases[(number % 10 < 5) ? number % 10 : 5]];
	}

	updateTimer() {
		let {text} = this.$wait.data();
		const time = this.timer + ' ' + this.declOfNum(this.timer, ['секунду', 'секунды', 'секунд']);
		text = text.replace('{{=time}}', time);
		this.$wait.html(text);
	}

	startTimer(time) {
		this.timer = time - 1;
		this.updateTimer();
		this.$el.addClass(this.options.classes.wait);
		clearInterval(this.interval);
		this.interval = setInterval(this.stopTimer.bind(this), 1000);
		return this;
	}

	stopTimer() {
		this.timer--;
		this.updateTimer();
		if (this.timer <= 0) {
			this.$el.removeClass(this.options.classes.wait);
			clearInterval(this.interval);
		}
		return this;
	}

	render() {
		const self = this;
		if (self.$el.length) {
			self.getDom();
			self.getHtmlOptions();
			self.$code.on('change input blur keypress focus', self.onInput.bind(self));
			self.$again.on('click', self.onResend.bind(self));
			self.$el.on('submit', self.onSubmit.bind(self));
			if (yotaPortlets.orderSim) {
				if (yotaPortlets.orderSim.wait) {
					self.startTimer(yotaPortlets.orderSim.wait);
				}
			}
		}
		return self;
	}
}



// WEBPACK FOOTER //
// ./app/portlets/site/order-sim/sms/sms.js